<template>
  <div class="email-login">
    <div class="email-login-container" v-if="!isRk()">
      <el-form v-loading="ldr">
        <el-form-item label="Email" required>
          <el-input v-model="email" placeholder="Введите email"/>
        </el-form-item>
        <el-form-item label="Контактный телефон" required>
          <el-input v-model="phone" placeholder="Введите контактный телефон"/>
        </el-form-item>
        <el-form-item label="Ваше имя">
          <el-input v-model="name" placeholder="Введите ваше имя"/>
        </el-form-item>
        <el-form-item label="Название компании">
          <el-input v-model="company" placeholder="Введите название компании"/>
        </el-form-item>
        <el-form-item label="Пароль" required>
          <el-input type="password" v-model="password" placeholder="Введите пароль "/>
        </el-form-item>
        <el-form-item label="Подтвердите пароль" required>
          <el-input type="password" v-model="confirmPassword" placeholder="Подтвердите пароль"/>
        </el-form-item>
        <el-button type="primary" @click="signUp">Сохранить</el-button>
      </el-form>
      <router-link to="/">
        <el-button>Отменить</el-button>
      </router-link>
    </div>
    <div v-else style="margin-top: 100px; display: flex; flex-direction: column; align-items: center; justify-content: center">
      <span>Регистрация возможна только с веб версии</span>

      <router-link to="/" style="margin-top: 32px">
        <el-button>Назад</el-button>
      </router-link>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import dayjs from 'dayjs';
import {copyDemoProject} from '../../firestore/demo';
import {createUserStat} from '../../firestore/stat';

export default {
  name: 'EmailLogin',

  data() {
    return {
      email: '',
      password: '',
      phone: '',
      name: '',
      company: '',
      error: null,
      view: null,
      ldr: false,
      loading: false,
      confirmPassword: '',
    };
  },
  created() {
    this.$router.replace({ query: {} })

  },
  methods: {
    isRk() {
      return localStorage.getItem('server') === 'rk'
    },
    signUp() {

      if (this.phone.length < 6) {
        return this.$notify.error({
          title: 'Ошибка',
          message: 'Для продолжения регистрации укажите корректный номер телефона',
          offset: 60,
        });
      }


      if (this.confirmPassword !== this.password) {
        this.$notify.error({
          title: 'Ошибка', message: 'Пароли не совпадают', offset: 60,
        });
      } else {
        this.ldr = true;
        this.$router.replace({ query: { lock: "1" } })

        authFirestore
          .createUserWithEmailAndPassword(String(this.email).toLowerCase().replace(/\s/g, ''), this.password)
          .then(() => {
            const user = authFirestore.currentUser;
            console.log(authFirestore.currentUser, 'authFirestore.currentUser')
            localStorage.setItem('user-register', JSON.stringify({
              company: this.company.trim(),
              phone: this.phone,
              name: this.name,
            }));

            const promises = [];
            promises.push(createUserStat({
              company: this.company.trim(),
              phone: this.phone,
              name: this.name.trim(),
              email: String(this.email).toLowerCase().replace(/\s/g, ''),
            }));

            // promises.push(copyDemoProject({
            //   company: this.company.trim(),
            //   phone: this.phone,
            //   name: this.name,
            // }));

            Promise.all(promises).then((response) => {
              // setTimeout(() => {
              //   this.ldr = false;
              // }, 200000);
              this.$router.push('/dashboard');
            })

            // user.sendEmailVerification().then(async () => {
            // }).catch((error) => {
            //   this.ldr = false;
            //   this.$notify.error({
            //     title: 'Ошибка', message: error, offset: 60,
            //   });
            // });
          }).catch(error => {
          this.ldr = false;

          if (error.code === 'auth/email-already-in-use') {
            this.$notify.error({
              title: 'Ошибка', offset: 60,
              message: 'Пользователь с таким email уже существует',
            });
          } else if (error.code === 'auth/invalid-email') {
            this.$notify.error({
              title: 'Ошибка', offset: 60,
              message: 'Введите корректный email',
            });
            this.ldr = false;
          } else {
            this.$notify.error({title: 'Ошибка', message: error});
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.email-login {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 60px;
}

.reset-password {
  display: flex;
  justify-content: flex-end;
  margin-bottom: -18px;
  color: #409EFF;
  text-decoration: none;

  span {
    cursor: pointer;

    &:hover {
      color: #66b1ff;
    }
  }
}

.email-login-container {
  max-width: 382px;
  width: calc(100% - 40px);

  button {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Authorization/EmailLogin.vue